import styled, { css } from "styled-components";
import { hexToRgba } from "@icarros/utils-react";
import { ids } from "@icarros/theme-react";
const { color, foundation_size, opacity, size, text } = ids || {};
const labelDisabled = css `
  background: ${hexToRgba(color.action.disabled.ids_color_action_disabled_variant, opacity.ids_opacity_soft)};
  border-radius: ${size.general.ids_size_general_4x}
    ${size.general.ids_size_general_4x} 0 0;
  cursor: not-allowed;
`;
export const StyledContainer = styled.div `
  position: relative;
  padding: 0 4px;
`;
export const TextAreaContainer = styled.div `
  display: flex;
  flex-direction: column;
  position: relative;
`;
export const StyledLabel = styled.label `
  pointer-events: none;
  transform-origin: left top;
  transition: 200ms ease all;
  position: absolute;
  top: 1px;
  width: 100%;
  ${({ isDisabled }) => isDisabled && labelDisabled}
  &.active {
    transform: translateY(-25px);
  }
`;
export const StyledTextArea = styled.textarea `
  display: flex;
  font-size: 100%;
  line-height: 25px;
  width: 312px;
  text-shadow: none;
  border: 0;
  ${text.label.ids_textStyle_label_large_regular};
  color: ${color.action.neutral.ids_color_action_neutral_variant};

  &:disabled {
    ${({ value }) => !!value &&
    css `
        background: ${hexToRgba(color.action.disabled.ids_color_action_disabled_variant, opacity.ids_opacity_soft)};
        color: ${color.action.neutral.ids_color_action_neutral_base};
      `}
    cursor: not-allowed;
  }
  &:focus {
    outline: 0;
  }

  @media screen and (max-width: ${foundation_size.screen.size_screen_1024}) {
    ::-webkit-resizer {
      display: none;
    }
  }

  ${({ maxLength }) => {
    if (!!maxLength)
        return css `
        @media screen and (min-width: ${foundation_size.screen.size_screen_1024}) {
          ::-webkit-resizer {
            display: none;
          }`;
    return;
}}
`;
export const StyledDividerContainer = styled.div `
  display: flex;
  position: relative;
`;
export const StyledIcon = styled.div `
  position: absolute;
  top: -40px;
  left: 85%;
`;
export const HelperTextContainer = styled.div `
  margin-top: 2px;
`;
export const StyledHelperTextIcon = styled.span `
  margin-right: 5px;
`;
//# sourceMappingURL=TextArea.style.js.map